import { FC, useEffect, useMemo } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { observer } from 'mobx-react-lite'
import { nanoid } from 'nanoid'

import { RoutingPaths } from 'app/routes/routes'

import { getOrCreateAviaSearchId } from 'entities/ticket/lib/avia-search-id'
import findTicketFormStore from 'entities/ticket/models/find-ticket/find-ticket-store'
import { DifficultRoute } from 'entities/ticket/models/find-ticket/models'

import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'
import { addDate, dateFormat } from 'shared/lib/dateFormat'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
// import { Button } from 'shared/ui/button'
import { Paper } from 'shared/ui/paper'
import { PopularDirectionsUi } from 'shared/ui/popular-directions'

import { popularDirectionAviaStore } from '../model'

import s from './styles.module.scss'

interface Props {}

export const PopularDirections: FC<Props> = observer(() => {
  const navigate = useNavigate()

  const { t } = useTranslation()

  const listPopular = popularDirectionAviaStore.getPopularDirections()

  const getPopularRoutes = () => {
    popularDirectionAviaStore.fetchPopularDirections()
  }

  const goPagePopular = (index: number) => {
    const selectedPopular = listPopular?.[index]

    if (!selectedPopular) return

    const dateNextDay = addDate({ count: 1, type: 'day' })

    const dataPrepared: DifficultRoute = {
      to: {
        cityName: selectedPopular?.arr?.city?.title,
        countryName: selectedPopular?.arr?.country,
        cityIataCode: selectedPopular?.arr?.airport?.code,
      },
      from: {
        cityName: selectedPopular?.dep?.city?.title,
        countryName: selectedPopular?.dep?.country,
        cityIataCode: selectedPopular?.dep?.airport?.code,
      },
      date:
        selectedPopular?.date ||
        dateFormat(dateNextDay, DATE_FORMAT_LIST.YEAR_FULL_DATE),
    }

    findTicketFormStore.onSelectRecommendation(dataPrepared)
    getOrCreateAviaSearchId(findTicketFormStore.formFindTicket)

    navigate(RoutingPaths.avia.search.path())
  }

  const goToPopular = () => {
    navigate(RoutingPaths.avia.popularDirection.path())
  }

  useEffect(() => {
    if (!listPopular?.length) {
      getPopularRoutes()
    }
  }, [])

  const preparedListPopular = useMemo(
    () =>
      listPopular?.map((popular) => ({
        id: String(nanoid()),
        image: popular?.city_logo || '',
        title: `${popular?.dep?.city?.title} - ${popular?.arr?.city?.title}`,
        price: String(popular?.start_price),
      })),
    [listPopular],
  )

  return (
    <Paper padding={[0, 0, 16]}>
      <div className={s.container}>
        <div className={s.header}>
          <p className={'bold-14'}>{t('popular_directions.title_avia')}</p>
          {/* <p className={s.subtitle}>{t('popular_directions.avia_subtitle')}</p> */}

          <button
            className={s.viewAll}
            onClick={goToPopular}
          >
            <span className="medium-14">
              {t('kyrgyzstan_block.offers.view_all')}
            </span>
            <AppIcon
              id={AllIcons.CHEVRON_RIGHT}
              width={12}
              height={12}
              className={s.arrowRight}
            />
          </button>
        </div>

        <div className={s.populars}>
          <PopularDirectionsUi
            goPagePopular={goPagePopular}
            populars={preparedListPopular}
          />
        </div>

        {/* <div className={s.button}>
          <Button
            variant="grey"
            onClick={goToPopular}
          >
            <span className={s.buttonText}>{t('popular_directions.more')}</span>
          </Button>
        </div> */}
      </div>
    </Paper>
  )
})
